/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedMoreWaysToBrowse_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SharedMobileLinksBlock_viewer" | "SharedRespLinksBlock_viewer">;
    readonly " $refType": "BuySharedMoreWaysToBrowse_viewer";
};
export type BuySharedMoreWaysToBrowse_viewer$data = BuySharedMoreWaysToBrowse_viewer;
export type BuySharedMoreWaysToBrowse_viewer$key = {
    readonly " $data"?: BuySharedMoreWaysToBrowse_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedMoreWaysToBrowse_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedMoreWaysToBrowse_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedMobileLinksBlock_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRespLinksBlock_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '0792555adee289bae2d476c15054c8db';
export default node;
